module.exports = __webpack_public_path__ + "img/electronic_use.a4da0ff4.svg";